// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ccWN","input":"styles_input__OTqBG"};